<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
<ng-container *ngIf="state.current === state.all.PASSWORD">
  <app-external-login
    [logo]="relatedInfo.company.logo ?? relatedInfo.org.logo"
    [title]="relatedInfo.company.name"
    [replacementIconNameAndStyling]="'tablet-with-charts.svg;icon-size-5;black-5'"
    [subtitle]="relatedInfo.org.name + ' invited you to fill KPI metrics'"
    [checkPassword]="checkPassword.bind(this)"
    (passwordOnSuccessEmitter)="proceedWithFetchedData($event)"
  />
</ng-container>
<div *ngIf="state.current === state.all.EMPTY"
     class="bg-white-12-mobile centered-vertically-column-container height-100vh column-gap-1 resize-index"
     data-qa="empty-state">
  <app-exclamation-mark class="icon-size-4p375 icon-size-4em-mobile opacity0p64"></app-exclamation-mark>
  <span class="title-1 bold600 opacity0p64 pd-bttm-0p75">
    Shared link expired or not valid.
  </span>
  <app-button
    data-qa="go-to-login-button"
    [additionalClasses]="'go-to-login-mobile'"
    [type]="'accent'"
    (click)="goToLogin()">
    Go to log in
  </app-button>
</div>
<div
  *ngIf="state.current === state.all.AUTHORIZED"
  data-qa="authorized-container">
  @if (!show.modalAfterSuccessfulSubmission) {
    <ng-container *ngVar="tabs.selected === tabs.all.at(-1) as isLastTabSelected">
      <div class="width-100pcnt padding-authorized-container space-between-horizontal-centered">
        <div class="start-row-container padding-left-1p5">
          <img class="logo-size pd-l-0p5 padding-right-1" [src]="relatedInfo.company.logo">
          <div class="tart-column-container">
            <span class="title-3 bold600 black-12">{{ relatedInfo.company.name }}</span>
            <div class="flex font-3 bold500">
              <span class="black-9">KPI metrics for &nbsp;</span>
              <span class="main-8">{{ relatedInfo.org.name }}</span>
            </div>
          </div>
        </div>
        <div class="centered-row-container pd-right-1p5">
          <div
            *ngIf="groupsWithAllPeriods.contact.isActivated
            && (groupsWithAllPeriods.contact.email || groupsWithAllPeriods.contact.name)"
            class="start-column-container padding-right-0p5">
            <app-button
              [size]="'medium'"
              [iconName]="'letter.svg'"
              [type]="'grey'"
              [buttonTooltip]="contactPersonTooltip"
              (buttonClick)="sendEmail()"
              (mouseenter)="contactPersonTooltip.showCondition = true"
              (mouseleave)="contactPersonTooltip.showCondition = false">
              {{ groupsWithAllPeriods.contact.name }} ({{ groupsWithAllPeriods.contact.email }})
            </app-button>
          </div>
        </div>
      </div>
      <div class="vertical-container-simple padding-1">
        <div class="section-item-wrapper">
          <div class="pd-bttm-1 position-rel">
            <div class="centered-row-container row-gap-0p5 height-2p5">
              @for (header of tabs.all; track header) {
                <div class="centered-row-container row-gap-0p5">
                  <!--Color:-->
                  <!--All tabs till selected have main-color background-->
                  <!--The last tab if selected also has main-color background-->
                  <div
                    class="width-1p875 height-1p875 centered-row-container bordered"
                    data-qa="external-company-progress-tab"
                    [ngClass]="$index <= tabs.all.indexOf(tabs.selected) || isLastTabSelected ? ['bg-main-8', 'white-12'] : ['black-7']">
                    <!--Text or icon:-->
                    <!--The last submit data tab if selected has telegram icon-->
                    <!--All previous tabs have check icon-->
                    <!--Selected and future tabs show their indexes-->
                    @if ($last && isLastTabSelected) {
                      <app-all-icons data-qa="external-company-progress-last" [iconNameAndStyling]="'send.svg; icon-size-1p25'"/>
                    } @else if ($index < tabs.all.indexOf(tabs.selected)) {
                      <app-all-icons data-qa="external-company-progress-check" [iconNameAndStyling]="'check.svg; icon-size-1p25'" />
                    } @else {
                      <span data-qa="external-company-progress-upcoming">{{ $index + 1 }}</span>
                    }
                  </div>
                  <span
                    data-qa="external-company-progress-header"
                    class="main-9"
                    [ngClass]="header === this.tabs.selected ? ['font-3', 'bold600'] : ['black-10']">
                    {{ header }}
                  </span>
                  @if (!$last) {
                    <div class="grey-line width-2"></div>
                  }
                </div>
              }
            </div>
            <div class="absolute-buttons-placeholder">
              <app-button
                *ngIf="tabs.selected !== tabs.all[0]"
                data-qa="external-company-button-prev"
                [bordersSquaredShape]="'full'"
                (buttonClick)="setPreviousTab()">
                Back
              </app-button>
              <app-button
                *ngIf="tabs.selected !== tabs.all[tabs.all.length-1]"
                data-qa="external-company-button-next"
                [type]="'accent'"
                [bordersSquaredShape]="'full'"
                (buttonClick)="setNextTab()">
                Next
              </app-button>
            </div>
          </div>
          @if (isLastTabSelected) {
            <div
              data-qa="external-company-user-form"
              class="centered-vertically-column-container height-30 column-gap-1"
              [formGroup]="submissionForm">
              <app-input
                data-qa="external-company-user-form-name"
                class="width-17p5"
                formControlName="name"
                [autofocus]="true"
                [title]="'Name'"
                [placeholder]="'Your name'"
                [bottomText]="submissionForm.controls.name.invalid && submissionForm.controls.name.dirty ? 'Please enter the name' : null"
              />
              <app-input
                data-qa="external-company-user-email"
                formControlName="email"
                class="width-17p5"
                [title]="'Email'"
                [placeholder]="'email@email.com'"
                [additionalClass]="submissionForm.controls.email.valid ? '' : 'error'"
                [bottomText]="submissionForm.controls.email.invalid && submissionForm.controls.email.dirty ?
                'Please provide an email' : null"
              />
              <app-button
                data-qa="external-company-user-form-submit"
                class="width-17p5"
                [disabled]="submissionForm.invalid"
                [bordersSquaredShape]="'full'"
                [type]="'accent'"
                [additionalClasses]="'width-100pcnt'"
                (buttonClick)="show.saveDialog = true">
                Submit data
              </app-button>
            </div>
          } @else {
            <app-company-request-group-table
              [form]="form"
              [groups]="groupsWithAllPeriods"
              [isActual]="tabs.isActualSelected"
              [password]="password"
              [token]="token"
              (showBulkUpload)="show.modalBulkUpload = true">
            </app-company-request-group-table>
          }
        </div>
      </div>
      <app-metric-bulk-upload-wrapper
        *ngIf="show.modalBulkUpload"
        [selected]="{
        company: relatedInfo.company,
        groups: groupsWithAllPeriods,
        role: tabs.isActualSelected ? metricDataRole.ACTUAL :metricDataRole.BUDGET
      }"
        [parent]="metricLocation"
        (closeEmitter)="afterBulkUpload($event)">
      </app-metric-bulk-upload-wrapper>
    </ng-container>
  } @else {
    <div class="width-100 height-60vh centered-vertically-column-container padding-top-10">
      <div class="centered-vertically-column-container bg-white-12 padding-10-15 br-1">
        <app-orca-logo
          data-qa="external-company-successful-logo"
          [logoType]="'black'"
          [logoWidthRem]="8"
          [logoHeightRem]="8">
        </app-orca-logo>
        <div class="centered-column-container column-gap-1">
          <span data-qa="external-company-successful-header" class="title-1 bold600">Thank you</span></div>
        <span data-qa="external-company-successful-text" class="font-3 black-9">Data submitted successfully</span>
      </div>
    </div>
  }
</div>

<app-modal-container
  *ngIf="show.saveDialog"
  [bigSize]="false"
  [title]="'Are you sure?'"
  [buttons]="{ apply: 'Continue', close: true}"
  (applyButtonClicked)="save()"
  (closeButtonClicked)="show.saveDialog = false">
  <div
    data-qa="proceed-dialog"
    class="centered-column-container">
    <span>All metric data will be sent to <span class="bold500">{{ relatedInfo.org.name }}.</span></span>
  </div>
</app-modal-container>
